import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipUpiComponent } from './payment-sip-upi.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentSipUpiIntentsModule } from '../payment-sip-upi-intents/payment-sip-upi-intents.module';
import { PaymentSipUpiTimerModule } from '../payment-sip-upi-timer/payment-sip-upi-timer.module';
import { PaymentMethodListModule } from '../payment-method-list/payment-method-list.module';
import { UpiInputComponent } from 'src/app/core/upi-input/upi-input.component';
import { TutorialComponent } from 'src/app/core/tutorial/tutorial.component';

@NgModule({
  declarations: [PaymentSipUpiComponent],
  exports: [PaymentSipUpiComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    PaymentSipUpiIntentsModule,
    PaymentSipUpiTimerModule,
    FormsModule,
    PaymentMethodListModule,
    TutorialComponent,
    UpiInputComponent
  ]
})
export class PaymentSipUpiModule { }
